import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded';
import Typography from '@mui/material/Typography';
import { TextAreaCardDisplay } from '../../../../components/cards/textAreaCardDisplay';
import { HtmlRenderer } from '../../../../components/htmlAreas/htmlRenderer';
import { IconWithLabelDisplay } from '../../../../components/iconWithLabelDisplay';
import { HISTORY_PANEL_HAND_SEPARATOR_COLOR, HISTORY_PANEL_HEADER_BACKGROUND_COLOR, HISTORY_PANEL_SUB_HEADER_BACKGROUND_COLOR, PURPLE_COLOR } from '../../../../styles/colors';
import { getCurrencyAmountString } from '../../../../utils/currencyUtils';
const HEADER_CONTAINER_BASE_CSS = css `
  padding: 3px 5px;
`;
const MAIN_HEADER_CONTAINER_CSS = css(HEADER_CONTAINER_BASE_CSS, css `
    background-color: ${HISTORY_PANEL_HEADER_BACKGROUND_COLOR};
  `);
const SUB_HEADER_CONTAINER_CSS = css(HEADER_CONTAINER_BASE_CSS, css `
    background-color: ${HISTORY_PANEL_SUB_HEADER_BACKGROUND_COLOR};
  `);
const SIDE_BETS_SUMMARY_CONTAINER_CSS = css `
  margin: 3px;
  padding: 3px;
  border: 2px solid ${PURPLE_COLOR};
  color: ${PURPLE_COLOR};
  border-radius: 5px;
`;
const SIDE_BET_PLAYER_CSS = css `
  background-color: ${HISTORY_PANEL_SUB_HEADER_BACKGROUND_COLOR};
  border-radius: 3px;
  margin: 0 2px;
  padding: 1px 3px;
`;
const HAND_END_DIV_CSS = css `
  background-color: ${HISTORY_PANEL_HAND_SEPARATOR_COLOR};
  height: 5px;
  min-height: 5px;
`;
function getContents(handHistoryEntry, isFourColorDeck) {
    switch (handHistoryEntry.type) {
        case 'hole-cards': {
            return (_jsxs(_Fragment, { children: ["Hole Cards:", ' ', handHistoryEntry.cards.map((card, i) => (_jsx(TextAreaCardDisplay, { card: card, isFourColorDeck: isFourColorDeck }, i)))] }));
        }
        case 'community-cards': {
            return (_jsxs(_Fragment, { children: [handHistoryEntry.streetName, ":", ' ', handHistoryEntry.cards.map((card, i) => (_jsx(TextAreaCardDisplay, { card: card, isFourColorDeck: isFourColorDeck }, i)))] }));
        }
        case 'text': {
            if (handHistoryEntry.headerType) {
                return (_jsx("div", { css: handHistoryEntry.headerType === 'main' ? MAIN_HEADER_CONTAINER_CSS : SUB_HEADER_CONTAINER_CSS, children: handHistoryEntry.text }));
            }
            return _jsx(_Fragment, { children: handHistoryEntry.text });
        }
        case 'html': {
            return _jsx(HtmlRenderer, { html: handHistoryEntry.html });
        }
        case 'revealed-cards': {
            return (_jsxs(_Fragment, { children: [handHistoryEntry.username, " shows:", ' ', handHistoryEntry.cards.map((card, i) => (_jsx(TextAreaCardDisplay, { card: card, isFourColorDeck: isFourColorDeck }, i)))] }));
        }
        case 'side-bets-summary': {
            const { jacksWonPerWinner, winners, losers } = handHistoryEntry;
            return (_jsxs("div", { css: SIDE_BETS_SUMMARY_CONTAINER_CSS, children: [_jsx("div", { children: _jsx(IconWithLabelDisplay, { label: 'Side Bets', icon: _jsx(CasinoRoundedIcon, {}) }) }), _jsxs("div", { children: ["Winner", winners.length > 1 ? 's' : '', " (+", getCurrencyAmountString(jacksWonPerWinner, 'jacks'), winners.length > 1 ? ' each' : '', "):", ' ', winners.map(({ name }) => (_jsx("span", { css: SIDE_BET_PLAYER_CSS, children: name }, name)))] }), _jsxs("div", { children: ["Loser", losers.length > 1 ? 's' : '', ":", ' ', losers.map(({ name }) => (_jsx("span", { css: SIDE_BET_PLAYER_CSS, children: name }, name)))] })] }));
        }
        case 'hand-end': {
            return _jsx("div", { css: HAND_END_DIV_CSS });
        }
    }
}
export const HistoryPanelEntryDisplay = ({ handHistoryEntry, isFourColorDeck }) => {
    return (_jsx(Typography, { variant: 'caption', component: 'div', sx: { fontSize: 'inherit' }, className: 'scaling-panel-contents', children: getContents(handHistoryEntry, isFourColorDeck) }));
};
